import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import CommissionRateService from '../../../Services/CommissionRateService';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ChooseCommissionPanel from './ChooseCommissionPanel';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ServiceItemService from '../../../Services/ServiceItemService';
import CommissionRateSearchParams from './CommissionRateSearchParams';
import ChangeCommissionStatusWindowDescription from './ChangeCommissionStatusWindowDescription';
import CommissionRateStatusUpdateItem from '../../../Domain/CommissionRateStatusUpdateItem';
import OpportunityCommissionRateItem from '../../../Domain/OpportunityCommissionRateItem';
import ServiceCommissionRateUpdateItem from '../../../Domain/ServiceCommissionRateUpdateItem';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import CommissionRatesGuideLink from './CommissionRatesGuideLink';

export default class OpportunityCommissionRatesAdmin extends React.Component {
  static defaultProps = {
    userId: 0,
    opportunityId: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      shownPanel: ShownPanelsEnum.None,
      searchItem: { UserId: props.userId, OpportunityId: props.opportunityId },
      searchParamsForSelect: new CommissionRateSearchParams(),
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
    };

    OpportunityCommissionRateItem.changeCommissionFunction = this.changeStatusFunction.bind(this);
    this.changeStatusFunction = this.changeStatusFunction.bind(this);
    this.multiChangeStatusFunction = this.multiChangeStatusFunction.bind(this);
    this.onCommissionSelected = this.onCommissionSelected.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  changeStatusFunction(item) {
    if (
      item.CommissionRateClosedOn &&
      dateTimeHelper.dateDiffInDays(new Date(item.CommissionRateClosedOn), new Date()) > 0 &&
      item.ServiceCommissionRateApprovalStatus === 1
    ) {
      const newParam = new CommissionRateSearchParams();
      newParam.UserId = this.props.userId;
      newParam.IsOrWillBeActive = true;
      newParam.Year = item.CommissionYearPeriod;
      this.setState({ selectedItem: item });
      ErrorMessage.SetApprove(
        "This commission rate is closed, the user's current active commission will be applied unless manually overridden.",
        () => this.setState({ shownPanel: ShownPanelsEnum.EditItem, searchParamsForSelect: newParam }),
        'Would you like to override the commission?',
        () => this.onCommissionSelected(null, true)
      );
      return;
    }

    this.changeStatusBaseFunction([item.ServiceId], item.ServiceCommissionRateApprovalStatus);
  }

  multiChangeStatusFunction() {
    const selected = this.state.itemList.filter((x) => x.Selected === true);
    this.changeStatusBaseFunction(
      selected.map((x) => x.ServiceId),
      selected[0].ServiceCommissionRateApprovalStatus
    );
  }

  changeStatusBaseFunction(idList, status) {
    const selectedItem = new CommissionRateStatusUpdateItem();
    selectedItem.ServiceIds = idList;
    selectedItem.UserId = this.props.userId;
    selectedItem.OldStatusId = status;
    selectedItem.allItemsInTheSearchSetAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    selectedItem.searchItem = this.state.searchItem;

    this.setState({ selectedItem: selectedItem, shownPanel: ShownPanelsEnum.StatusUpdate });
  }

  onCommissionSelected(item, automatic = false) {
    const body = new ServiceCommissionRateUpdateItem();
    body.ServiceId = this.state.selectedItem.ServiceId;
    body.UpdateCommissionRateAutomatically = automatic;
    body.OverrideCommissionRateId = item ? item.CommissionRateId : null;

    ServiceItemService.UpdateCommissionRate(body)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage('OCRA88');
          return;
        }
        this.refresh(true);
        ErrorMessage.SetNotification('Commission rate has been updated.');
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('OCRA95');
      });
  }

  canChangeStatus() {
    const selected = this.state.itemList.filter((x) => x.Selected === true);
    if (!selected || selected.length === 0) return false;

    const nonPending = selected.filter((x) => x.ServiceCommissionRateApprovalStatus !== 1);
    if (nonPending.length > 0) return false;

    return true;
  }

  refresh(refresh) {
    if (refresh) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          className={'InnerMenuButtonFigmaList'}
          buttons={[
            {
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Center,
              iconName: 'fa-solid fa-rotate-right',
              onClick: this.multiChangeStatusFunction,
              tooltip: 'Change Status',
              disabled: !this.canChangeStatus(),
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.StatusUpdate,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={ChangeCommissionStatusWindowDescription}
            errorCode='CRA157'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <ChooseCommissionPanel
            clickOnCancel={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            clickOnSubmit={this.onCommissionSelected}
            searchItem={this.state.searchParamsForSelect}
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        <CommissionRatesGuideLink />
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={OpportunityCommissionRateItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={CommissionRateService.GetListBySearchingForOpportunity}
          convertDBItemsFunction={CommissionRateService.ConvertForOpportunityDBItems}
          showSearchStrip={false}
          searchItem={this.state.searchItem}
          orderBy='ServiceId'
          orderDirection='Asc'
          errorCode='OCRA187'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
        />
      </div>
    );
  }
}
